export enum ASPECT_RATIO {
  '2:3' = '150%',
  '16:9' = '56.25%',
  '1:1' = '100%',
  '4:3' = '75%',
  'default' = 0
}
